// /src/pages/private/members/rosterTools/components/rosterFileTools/RosterProfileThemeCustomizeModal.jsx

import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import AccountProfileThemeSection from '../../../../settings/account/AccountProfileThemeSection';

export default function RosterProfileThemeCustomizeModal({
  isOpen,
  onClose,
  onApplied = null,
}) {
  const panelRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="roster-profile-theme-modal-overlay"
      onClick={(event) => {
        if (panelRef.current && !panelRef.current.contains(event.target)) {
          onClose?.();
        }
      }}
      role="presentation"
    >
      <div
        ref={panelRef}
        className="roster-profile-theme-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="roster-profile-theme-modal-title"
      >
        <div className="roster-profile-theme-modal__header">
          <h3 id="roster-profile-theme-modal-title" className="roster-profile-theme-modal__title">
            Customize profile theme
          </h3>
          <button
            type="button"
            className="roster-profile-theme-modal__close"
            onClick={onClose}
            aria-label="Close theme customize"
          >
            ✕
          </button>
        </div>
        <div className="roster-profile-theme-modal__body">
          <AccountProfileThemeSection
            className="roster-profile-theme-modal__card"
            onApplied={onApplied}
          />
        </div>
      </div>
    </div>,
    document.body,
  );
}
